import * as ActionTypes from '../constants/action_types'

// -----------------------------------------------------------------------------
// API Calls

export function setSelectedSidebarNav (nav) {
  return {
    type: ActionTypes.SIDEBAR_SELECTED_NAV,
    nav
  }
}
